import { ReactNode, ComponentType, PropsWithChildren } from 'react'

interface ITransformationOption<P = PropsWithChildren> {
  value: string
  Comp?: ComponentType<P>
  props?: Record<string, unknown>
}

export const transformTextVariables = (
  text: string,
  options: ITransformationOption[]
): ReactNode => {
  if (!text || !Array.isArray(options)) return text

  const parts = text.split('%s')
  const result: (string | ReactNode)[] = [parts[0]]

  options.forEach((option, index) => {
    const { value = '', Comp, props = {} } = option
    const nextText = parts[index + 1] ?? ''

    const transformedValue = Comp ? (
      // eslint-disable-next-line react/no-array-index-key
      <Comp key={`transform-${index}`} {...props}>
        {value}
      </Comp>
    ) : (
      value
    )

    result.push(transformedValue, nextText)
  })

  return result
}

export const replaceTranslationVariables = (
  translationText: string,
  replaceValues: string[]
): string => {
  return replaceValues.reduce((acc, currentValue) => {
    return acc.replace('%s', currentValue).replace('٪s', currentValue)
  }, translationText)
}
